export default "../c2970e0886d75e138651d4f2ed398801.jpg";